import { Separator } from "./ui/separator";

interface SeparatorWithTextProps {
  text: string;
}

const SeparatorWithText = ({ text }: SeparatorWithTextProps) => {
  return (
    <div className="flex items-center my-4" role="separator" aria-label={text}>
      <Separator
        className="flex-1 h-px bg-gray-300/70 dark:bg-gray-600"
        aria-hidden
      />
      <span className="px-3 text-center text-sm font-medium">{text}</span>
      <Separator
        className="flex-1 h-px bg-gray-300/70 dark:bg-gray-600"
        aria-hidden
      />
    </div>
  );
};

export default SeparatorWithText;
